// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React from "react";
import {useDispatch} from "react-redux";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {ModuleProvider, useModuleContext} from "../ModuleContext";
import {ModuleProvider as ChatModuleProvider, useModuleContext as useChatModuleContext} from "../../Chat/ModuleContext";
import {AESVG} from "../../../../_emywork/components/svg";
import {AEButton} from "../../../../_emywork/components/buttons";
import {useIntl} from "react-intl";
import {AERating} from "../../../../_emywork/components/rating";
import * as actions from "../_redux/actions";
import { AELabels} from "../../../../_emywork/components/AELabel";
import {AETruncate, localField} from "../../../../_emywork/helpers/UIHelper";
import {AEUserBadge} from "../../../../_emywork/components/AEBadge";
import {AERole} from "../../../../_emywork/components/AERole";
import {roles} from "../../../App";
import {AELink} from "../../../../_emywork/components/AELink";
import {CONTEXT} from "../helpers/ModuleHelpers";
import {HTTP_UPDATED} from "../../../../_emywork/helpers/AxiosHelpers";
import {AEAvatar} from "../../../../_emywork/components/AEAvatar";
import {HireModal} from "../dialogs/hireModal";
import {Dropdown} from "react-bootstrap";
import {DropdownCustomToggler} from "../../../../_metronic/_partials/dropdowns";
import {EntityCard as EmyProjectEntityCard} from "../../EmyProjects/componants/EntityCard";


export const EntityCard = props =>(
  <ModuleProvider>
    {/*<HireModal />*/}
    <EntityCardContent {...props} />
  </ModuleProvider>
)


function EntityCardContent({
  entity,
  size= "md",
  onUpdate ,
  editAction = false,
  detailsAction = false,
  sendProposalAction= false,
  deleteAction = false,
  chatAction = false,
  className = '',
}) {

  const { formatMessage } = useIntl()
  const dispatch  = useDispatch()
  const { openDetailsPage, openProposalDialog, openHireDialog, getDetailsPath} = useModuleContext()
  const {id, price, note, status, provider_status, created_at, project, created_by} = entity;

  return (
    <EmyProjectEntityCard
      size={"xs"}
      entity={project}
    />
  )
}
